/* Review interactions stay inside the two Abundance review blocks. */
(() => {
  'use strict';
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initializeTop(root) {
    if (root.dataset.enhanced) return;
    const track = root.querySelector('[data-review-track]');
    if (!track) return;
    root.dataset.enhanced = 'true';
    const previous = root.querySelector('[data-review-previous]');
    const next = root.querySelector('[data-review-next]');
    function measure() {
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      root.querySelectorAll('[data-review-more]').forEach(button => {
        const quote = root.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
        if (quote && button.getAttribute('aria-expanded') !== 'true') {
          button.hidden = quote.scrollHeight <= quote.clientHeight + 2;
        }
      });
    }
    function slide(direction) {
      const first = track.querySelector('[data-review-slide]');
      const gap = parseFloat(getComputedStyle(track).gap) || 20;
      track.scrollBy({ left: direction * ((first?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: reduced() ? 'auto' : 'smooth' });
    }
    previous.addEventListener('click', () => slide(-1));
    next.addEventListener('click', () => slide(1));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      slide(event.key === 'ArrowLeft' ? -1 : 1);
    });
    track.addEventListener('scroll', measure, { passive: true });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-review-more]');
      if (!button || !root.contains(button)) return;
      const quote = root.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
      if (!quote) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      quote.toggleAttribute('data-expanded', expanded);
      button.querySelector('[data-label-more]').hidden = expanded;
      button.querySelector('[data-label-less]').hidden = !expanded;
    });
    const observer = new ResizeObserver(measure);
    observer.observe(track);
    document.fonts?.ready.then(measure);
    measure();
  }

  function initializeGrid(root) {
    if (root.dataset.enhanced) return;
    const grid = root.querySelector('[data-hxzr-grid-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-hxzr-grid-card]'));
    const filter = root.querySelector('[data-hxzr-grid-filter]');
    const more = root.querySelector('[data-hxzr-grid-showmore]');
    const status = root.querySelector('[data-hxzr-grid-status]');
    const empty = root.querySelector('[data-hxzr-grid-empty]');
    let limit = Number(root.dataset.initialCount) || 14;
    root.dataset.enhanced = 'true';
    root.querySelector('[data-hxzr-grid-filter-wrap]').hidden = false;
    function measure() {
      grid.querySelectorAll('[data-hxzr-grid-expand]').forEach(button => {
        if (button.getAttribute('aria-expanded') === 'true') return;
        const quote = button.previousElementSibling;
        button.hidden = quote.scrollHeight <= quote.clientHeight + 2;
      });
    }
    function render() {
      const rating = filter.value;
      const matching = cards.filter(card => rating === 'all' || Number(card.dataset.rating) >= Number(rating));
      const visible = matching.slice(0, limit);
      grid.replaceChildren(...visible);
      empty.hidden = matching.length > 0;
      more.hidden = visible.length >= matching.length;
      status.textContent = `Showing ${visible.length} of ${matching.length} reviews`;
      measure();
    }
    filter.addEventListener('change', () => { limit = Number(root.dataset.initialCount) || 14; render(); });
    more.addEventListener('click', () => { limit += 8; render(); });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-hxzr-grid-expand]');
      if (!button || !root.contains(button)) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.previousElementSibling.classList.toggle('is-expanded', expanded);
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
    });
    const observer = new ResizeObserver(measure);
    observer.observe(grid);
    document.fonts?.ready.then(measure);
    render();
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-hxzr-top]').forEach(initializeTop);
    scope.querySelectorAll('[data-hxzr-grid]').forEach(initializeGrid);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
